<template>
  <form class="mt-4" @submit.prevent="submitZipcodeForm" @keyup.enter="submitZipcodeForm">
    <TextField
      id="zipcode-input"
      v-model="zipcodeValue"
      labelName="ZIP code"
      name="postal-code"
      type="text"
      maxlength="5"
      pattern="[0-9]*"
      inputmode="numeric"
      class="mb-16"
      aria-label="Five digit zip code"
      :limit-input-to-pattern="true"
    />
    <Dropdown id="distance-input" v-model="distanceValue" labelName="Max distance" class="mb-24" :options="distanceOptions" />
    <div class="w-full flex flex-row-reverse">
      <Button
        id="filterTokenSave"
        :value="buttonText"
        type="submit"
        size="medium"
        class="w-full"
        :class="!alwaysFullWidthButton && ' sm:w-auto'"
      />
    </div>
  </form>
</template>

<script lang="ts">
import { v4 as uuidv4 } from 'uuid';
import TextField from '../../textfield/TextField.vue';
import Dropdown from '../../dropdown/Dropdown.vue';
import Button from '../../button/Button.vue';

export default {
  name: 'ZipCode',
  components: { TextField, Dropdown, Button },
  props: {
    zipcode: {
      default: '',
      type: String,
    },
    distance: {
      default: '',
      type: String,
    },
    closeModal: {
      type: Function,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Save',
    },
    alwaysFullWidthButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    resetPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      zipcodeValue: this.zipcode,
      distanceValue: this.distance,
    };
  },
  computed: {
    distanceOptions() {
      return [
        { value: 1, display: '1 mi' },
        { value: 2, display: '2 mi' },
        { value: 5, display: '5 mi' },
        { value: 10, display: '10 mi' },
        { value: 15, display: '15 mi' },
        { value: 25, display: '25 mi' },
        { value: 40, display: '40 mi' },
        { value: 50, display: '50 mi' },
      ];
    },
  },
  methods: {
    submitZipcodeForm() {
      this.closeModal();

      const { query } = this.$route;
      // If the zipcode and distance are the same as the query, don't update the query
      if (this.zipcodeValue === query.zipcode && this.distanceValue === query.distance) return;

      const locationData = {
        zipcode: this.zipcodeValue,
        distance: this.distanceValue,
        sid: uuidv4(),
      };

      const pageData = {} as any;
      if (this.resetPage) pageData.page = 1;
      this.$router?.push({ query: { ...query, ...locationData, ...pageData } });

      // Emit the filter change event
      this.$emit('filter-applied', {
        zipcode: this.zipcodeValue,
        distance: this.distanceValue,
      });
    },
  },
};
</script>
